import React from 'react';

import Select from 'components/atoms/Select';

const LanguageSelector = ({
	// redux data
	lanData,
	lanList,

	// props
	selectedLanguage = 'zh-TW',
	onSelect,
	selectBoxConfig,
	optionConfig,
}) => (
	<div>
		<Select
			options={lanList.map(lang => lanData[lang])}
			selected={lanData[selectedLanguage]}
			selectBoxConfig={{
				triangle: false,
				...selectBoxConfig,
			}}
			optionConfig={optionConfig}
			onSelect={onSelect}
		/>
	</div>
);

export default LanguageSelector;



// WEBPACK FOOTER //
// ./src/components/molecules/LanguageSelector/component.js